import React from 'react';
import UsersTable from '../../../components/tables/usersTable';

const Users = () => (
  <UsersTable />
);

export default Users;
